<template>
  <b-modal :id="id" ref="modal" :title="modalTitle" title-class="font-18" v-bind="$attrs" @ok="handleOk">
    <template #modal-header-close>
      <div>
        <svg fill="#30345B" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM14.3 14.3C14.2075 14.3927 14.0976 14.4663 13.9766 14.5164C13.8557 14.5666 13.726 14.5924 13.595 14.5924C13.464 14.5924 13.3343 14.5666 13.2134 14.5164C13.0924 14.4663 12.9825 14.3927 12.89 14.3L10 11.41L7.11 14.3C6.92302 14.487 6.66943 14.592 6.405 14.592C6.14057 14.592 5.88698 14.487 5.7 14.3C5.51302 14.113 5.40798 13.8594 5.40798 13.595C5.40798 13.4641 5.43377 13.3344 5.48387 13.2135C5.53398 13.0925 5.60742 12.9826 5.7 12.89L8.59 10L5.7 7.11C5.51302 6.92302 5.40798 6.66943 5.40798 6.405C5.40798 6.14057 5.51302 5.88698 5.7 5.7C5.88698 5.51302 6.14057 5.40798 6.405 5.40798C6.66943 5.40798 6.92302 5.51302 7.11 5.7L10 8.59L12.89 5.7C12.9826 5.60742 13.0925 5.53398 13.2135 5.48387C13.3344 5.43377 13.4641 5.40798 13.595 5.40798C13.7259 5.40798 13.8556 5.43377 13.9765 5.48387C14.0975 5.53398 14.2074 5.60742 14.3 5.7C14.3926 5.79258 14.466 5.90249 14.5161 6.02346C14.5662 6.14442 14.592 6.27407 14.592 6.405C14.592 6.53593 14.5662 6.66558 14.5161 6.78654C14.466 6.90751 14.3926 7.01742 14.3 7.11L11.41 10L14.3 12.89C14.68 13.27 14.68 13.91 14.3 14.3Z"
              fill="#30345B"/>
        </svg>
      </div>
    </template>
    <template #modal-footer="{ ok, cancel, hide }">
      <b-button size="lg" variant="primary" @click="ok()">
        Simpan
      </b-button>
    </template>
    <div class="col-sm delete-item">
      <div :class="`row g-2 ${key === 0 ? '' : 'mt-2'}`">
        <validation-provider v-slot="{ validated, errors }" :name="lodash.upperFirst(nameLabel)"
                             :vid="`additional_fees.${key}.name`" class="col-md-6"
                             rules="required">
          <b-form-group :invalid-feedback="errors[0]"
                        :label="lodash.upperFirst(nameLabel)" :state="errors[0] ? false : (validated ? true : null)">
            <b-form-input :id="`${_uid}-name`" v-model="name" :name="`additional_fees[${key}][name]`"
                          :placeholder="lodash.upperFirst('Ex: PPN')"
                          :state="errors[0] ? false : (validated ? true : null)" type="text"></b-form-input>
          </b-form-group>
        </validation-provider>
        <validation-provider v-slot="{ validated, errors }" :name="lodash.upperFirst(totalLabel)"
                             :vid="`additional_fees.${key}.total`" class="col-md-6"
                             rules="required|gt:0">
          <b-form-group :invalid-feedback="errors[0]"
                        :label="`${lodash.upperFirst(totalLabel)}`"
                        :state="errors[0] ? false : (validated ? true : null)">
            <numeral-input :id="`${_uid}-value`" v-model="total" :name="`additional_fees[${key}][total]`"
                           :placeholder="lodash.upperFirst('Ex: 1000')"
                           :state="errors[0] ? false : (validated ? true : null)"
                           format="$ 0,0.[00]" lazy-formatter required
                           style="text-align: right"/>
          </b-form-group>
        </validation-provider>
      </div>
      <div :key="`additional_fees.key.${key}.delete`" class="row g-2 mt-2">
      </div>
    </div>
  </b-modal>
</template>

<script>

import NumeralInput from "@/components/inputs/numeral.vue";

export default {
  name: 'PurchaseOrderAdditionalItemModal',
  components: {NumeralInput},
  props: {
    id: {
      type: String,
      default: 'purchase-order-additional-item'
    },
    modalTitle: {
      type: String,
      default: 'Additional Item'
    },
    nameLabel: {
      type: String,
      default: 'Name'
    },
    totalLabel: {
      type: String,
      default: 'Total'
    },
  },
  data() {
    return {
      name: '',
      total: '',
      key: this.id
    }
  },
  mounted() {
    // this.list = JSON.parse(JSON.stringify(this.items))
  },
  methods: {
    handleOk() {
      this.$emit('ok', {
        name: this.name,
        total: this.total,
      })
      this.name = ''
      this.total = ''
    },
    addItem() {
      this.$emit('add-item')
    },
    removeItem(key) {
      this.$emit('remove-item', key)
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep {
  .close {
    opacity: 1 !important;
  }
}
</style>